var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.thankYou
    ? _c("modal", { ref: "thankyou" }, [
        _c("div", { staticClass: "thankyou" }, [
          _c("h2", [_vm._v("Awesome!")]),
          _vm._v(" "),
          _c("p", [_vm._v("You're on your way to remove manual tasks!")]),
          _vm._v(" "),
          _c("img", {
            attrs: {
              src: require("@/assets/img/safe-online-logo.jpg"),
              alt: "DataMapper logo"
            }
          })
        ])
      ])
    : _c("modal", { ref: "signup", attrs: { onClosed: _vm.onClosed } }, [
        _c(
          "form",
          {
            staticClass: "grid email-signup",
            attrs: {
              action:
                "https://forms.hubspot.com/uploads/form/v2/3937313/0bbfd302-252b-4759-a1b7-d36c71266e88",
              method: "post"
            }
          },
          [
            _c("h3", [_vm._v("Sign up to be an early beta tester")]),
            _vm._v(" "),
            _c("div", { staticClass: "unit w-1-2" }, [
              _c("label", { attrs: { for: "firstName" } }, [
                _vm._v("\n        First Name:\n        "),
                _c("input", {
                  attrs: {
                    type: "text",
                    id: "firstName",
                    name: "firstName",
                    placeholder: "Your first name",
                    required: ""
                  }
                })
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "unit w-1-2" }, [
              _c("label", { attrs: { for: "lastName" } }, [
                _vm._v("\n        Last Name:\n        "),
                _c("input", {
                  attrs: {
                    type: "text",
                    id: "lastName",
                    name: "lastName",
                    placeholder: "Your last name",
                    required: ""
                  }
                })
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "unit w-1-2" }, [
              _c("label", { attrs: { for: "jobTitle" } }, [
                _vm._v("\n        Job title:\n        "),
                _c("input", {
                  attrs: {
                    type: "text",
                    id: "jobTitle",
                    name: "jobTitle",
                    placeholder: "Your title",
                    required: ""
                  }
                })
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "unit w-1-2" }, [
              _c("label", { attrs: { for: "companyName" } }, [
                _vm._v("\n        Company:\n        "),
                _c("input", {
                  attrs: {
                    type: "text",
                    id: "companyName",
                    name: "companyNAme",
                    placeholder: "Company name",
                    required: ""
                  }
                })
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "unit w-1-2" }, [
              _c("label", { attrs: { for: "signupEmail" } }, [
                _vm._v("\n        Email:\n        "),
                _c("input", {
                  attrs: {
                    type: "email",
                    id: "signupEmail",
                    name: "email",
                    placeholder: "Company email",
                    required: ""
                  }
                })
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "unit w-1-2 cta" }, [
              _c("button", { staticClass: "simple" }, [_vm._v("Sign up")])
            ]),
            _vm._v(" "),
            _c("input", {
              attrs: { type: "hidden", name: "hs_context" },
              domProps: { value: _vm.hsContext }
            })
          ]
        )
      ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-264ab4fe", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-264ab4fe","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./apps/comps/SignupModal/SignupModal.vue
// module id = 569
// module chunks = 0